<div class="requested-resources-pills">
  @for (column of pillColumns; track $index) {
    <div class="pill-column">
      @for (opt of column; track opt.value) {
        <div class="requested-pill" [class.active]="countFor(opt.value) > 0">
          <button
            type="button"
            class="pill-step pill-step-remove"
            [disabled]="countFor(opt.value) === 0"
            (click)="decrement(opt.value)"
            [attr.aria-label]="'Remove one ' + opt.label"
            title="Remove one"
          >
            <mat-icon>remove_circle</mat-icon>
          </button>

          <span class="pill-label">{{ opt.label }}</span>
          <span class="pill-count">{{ countFor(opt.value) }}</span>

          <button
            type="button"
            class="pill-step pill-step-add"
            (click)="increment(opt.value)"
            [attr.aria-label]="'Add one ' + opt.label"
            title="Add one"
          >
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
